import React from "react";

const SEO = ({
    title,
    description,
    url,
    image,
    type = "website",
    schema,
    keywords,
}) => {
    const siteTitle = "Hiren Hadiya";
    const defaultDescription = "Hiren Hadiya Blogs - Portfolio and Tech Insights";
    const siteUrl = process.env.REACT_APP_URL || "https://hadiya.in";
    const defaultImage = `${siteUrl}/logo512.png`;

    const metaTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const metaDescription = description || defaultDescription;
    const metaUrl = url ? `${siteUrl}${url}` : siteUrl;
    const metaImage = image || defaultImage;

    return (
        <>
            {/* Standard Metadata */}
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={metaUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:url" content={metaUrl} />
            <meta property="og:image" content={metaImage} />
            <meta property="og:site_name" content={siteTitle} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={metaImage} />
            <meta name="twitter:creator" content="@hirenhadiya" />

            {/* Schema.org JSON-LD */}
            {schema && (
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            )}
        </>
    );
};

export default SEO;
